import type { MessagingCreateChatRoomBodyRoomInfo } from './messagingCreateChatRoomBodyRoomInfo';

export type MessagingCreateChatRoomBody = {
  /** 참여자 ID 목록 */
  participantIds: number[];
  /** 채팅방 정보 */
  roomInfo?: MessagingCreateChatRoomBodyRoomInfo;
};
